import React from 'react';

const CameraIcon = (props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M15.691 8.5C15.3122 8.5 14.9659 8.286 14.7966 7.94721L14.0729 6.5H9.92705L9.20344 7.94721C9.03405 8.286 8.68779 8.5 8.30902 8.5H5.5V16.5H18.5V8.5H15.691ZM8 7H5C4.44772 7 4 7.44772 4 8V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V8C20 7.44772 19.5523 7 19 7H16L15.2764 5.55279C15.107 5.214 14.7607 5 14.382 5H9.61803C9.23926 5 8.893 5.214 8.72361 5.55279L8 7Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12ZM12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5Z" fill="currentColor" />
  </svg>
);

export default React.memo(CameraIcon);
